import { useState } from 'react';
import { useDelayCall } from '@equifinance/shared';
import useProductsApi, { DipTypes } from '../../api/useProductsApi';

export type Summary = {
  id: string,
  applicationId: string,
  productName: string,
  ltv: number,
  termInMonths: number,
  netLoanAmount: number,
  addedFeesAmount: number,
  grossLoanAmount: number,
  monthlyPayment: number,
  balanceToCustomer: number,
  totalConsolidationAmount: number,
  surplusIncomeResult: number,
  stressedSurplusIncomeResult: number,
  monthlySavings: number,
  decisionInPrincipleOutcome: DipTypes,
  insolvencyRuleResult: boolean,
  insolvencyRuleValue: number,
}

export const defaultSummary: Summary = {
  id: '',
  applicationId: '',
  totalConsolidationAmount: 0,
  addedFeesAmount: 0,
  balanceToCustomer: 0,
  decisionInPrincipleOutcome: DipTypes.FAIL,
  grossLoanAmount: 0,
  ltv: 0,
  monthlyPayment: 0,
  netLoanAmount: 0,
  productName: '',
  stressedSurplusIncomeResult: 0,
  surplusIncomeResult: 0,
  termInMonths: 0,
  monthlySavings: 0,
  insolvencyRuleResult: false,
  insolvencyRuleValue: 0,
};

export function useSummary(accountId?: string, productsResultDigest?: string | null, creditSearchCompleted?: boolean) {
  const [summary, setSummary] = useState<Summary>(defaultSummary);

  const { getProductsSummary } = useProductsApi();

  const fetchProductsSummary = async () => {
    if (accountId) {
      setSummary(await getProductsSummary(accountId));
    }
  };

  useDelayCall(() => {
    if (accountId && creditSearchCompleted) {
      (async () => {
        await fetchProductsSummary();
      })();
    }
  }, [accountId, productsResultDigest, creditSearchCompleted], true);

  return { summary, fetchProductsSummary };
}
